import React from 'react';
import { Link } from 'react-router-dom';
import BLOGS from '../data/blogData';

export default function BlogSection() {
    return (
        <section className="py-16 md:py-24 px-4 md:px-6 max-w-[1200px] mx-auto" id="blog">
            <div className="mb-16 reveal">
                <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-container text-on-primary-container rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                    <i className="fa-solid fa-pen-nib"></i> Blog
                </span>
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-on-surface mb-2">Words & Thoughts</h2>
                <p className="text-[1.0625rem] text-on-surface-variant max-w-[560px] leading-relaxed">
                    Writing helps me think clearly. Here are my posts on engineering, tools, and my point of views.
                </p>
            </div>

            <div className="flex flex-col gap-6">
                {BLOGS.map((b, i) => (
                    <Link
                        to={`/blog/${b.slug}`}
                        key={i}
                        className={`flex flex-col md:flex-row bg-surface-container rounded-2xl overflow-hidden shadow-1 hover:translate-x-2 hover:shadow-3 transition-all duration-400 ease-emphasized reveal reveal-delay-${i + 1}`}
                    >
                        {/* Accent bar */}
                        <div className="w-full h-1 md:w-1.5 md:h-auto shrink-0" style={{ background: b.accentColor }} />
                        {/* Content */}
                        <div className="p-6 md:px-8 flex-1">
                            <div className="flex items-center gap-4 mb-2 text-[0.8125rem] text-on-surface-variant">
                                <span className="flex items-center gap-1"><i className="fa-regular fa-calendar"></i> {b.date}</span>
                                <span className="flex items-center gap-1"><i className="fa-regular fa-clock"></i> {b.readTime}</span>
                            </div>
                            <h3 className="text-[1.375rem] font-bold text-on-surface mb-2 leading-snug">{b.title}</h3>
                            <p className="text-[0.9375rem] text-on-surface-variant leading-relaxed mb-4">{b.excerpt}</p>
                            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:gap-3 transition-all duration-200">
                                Read article <i className="fa-solid fa-arrow-right"></i>
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}
